import request, { appendApiUrl } from '@/utils/request'
import { deleteEmpty } from './common.js'

// coda 校验freefire游戏id
export const checkUser = (options = {}, config = {}) => {
  return request.postJson(
    {
      url: appendApiUrl('/order/cdcheck/user'),
      data: { ...deleteEmpty(options) },
    },
    {
      showLoading: config.showLoading,
      showErrorToast: config.showErrorToast,
    }
  )
}
